import React from 'react'

import { Tabs } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Earnings from './Earnings'
import EligibleModels from './EligibleModels'
import { useSubscriptionsContext } from '../Context/SubscriptionsContext'
import { validTabs } from '../Static/constants'

const tabsComponents = {
  [validTabs.eligibleModels]: EligibleModels,
  [validTabs.earnings]: Earnings,
}

function Subscriptions() {
  const { activeTab, handleTabChange, translate } = useSubscriptionsContext()

  const TabComponent = tabsComponents[activeTab]

  const tabs = [
    { id: validTabs.eligibleModels, title: translate('my_subscriptions.tabs.eligible_models') },
    { id: validTabs.earnings, title: translate('my_subscriptions.tabs.earnings'), disabled: true },
  ]

  return (
    <div className="cgt-mt-20 my-subscriptions-tabs-container">
      <div className="cgt-mb-20">
        <Tabs
          className="subscriptions-tabs"
          activeTabId={activeTab}
          onClick={handleTabChange}
          tabs={tabs}
        />
      </div>

      <div id="active-tab-content">
        <TabComponent />
      </div>
    </div>
  )
}

export default Subscriptions
